module.exports = __webpack_public_path__ + "img/ltkaustralia-3x.b047496.jpg";